import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SearchInput.css';
import { isMobile } from '../lib/util';

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };
  }

  updateInputValue = (evt) => {
    this.setState({
      inputValue: evt.target.value,
    });
  };

  handleClick = () => {
    if (this.state.inputValue.length > 0) {
      this.props.history.push(`/search/${this.state.inputValue}`);
    }
    this.setState({
      inputValue: '',
    });
    this.props.toggleSearch({
      closeOnly: false,
    });
  };

  handleKeyUp = (e) => {
    // handle enter
    if (e.keyCode === 13) {
      this.handleClick();
    }
  };

  render() {
    return (
      // <Link className="navbar-item navbar-item-search" to="/search/msa" />
      <div className="SearchInput">
        <div className="field has-addons">
          <p className="control SearchInput-input-control">
            <input
              className="input"
              id="SearchInput-input"
              type="text"
              placeholder={isMobile ? "產品名稱、銷售據點、最新消息" : "搜尋：產品名稱、銷售據點、最新消息"}
              value={this.state.inputValue}
              onChange={this.updateInputValue}
              onKeyUp={this.handleKeyUp}
            />
          </p>
          <p className="control">
            <button className="button" onClick={this.handleClick}>
              <span className="icon icon-search" />
            </button>
          </p>
        </div>
      </div>
    );
  }
}

SearchInput.propTypes = {
  toggleSearch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

SearchInput.defaultProps = {
  history: {
    push: undefined,
  },
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/SearchInput.js